import {
  Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField
} from '@material-ui/core';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { makeStyles } from '@material-ui/styles';
import axios2 from 'axios';
import clsx from 'clsx';
import { DeviceUUID } from 'device-uuid';
import { Base64 } from 'js-base64';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { isMobile, mobileModel } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import {
  setIpAddress, setSessionToken, setUserSession, setUserSessionFromLocale
} from 'src/utils/Common';
import { NavBarAdetleriAl } from 'src/utils/storage/NavBarAdet';
import validate from 'validate.js';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'zorunlu alan' },
    email: true
  },
  password: {
    presence: { allowEmpty: false, message: 'zorunlu alan' }
  }
};

const useStyles = makeStyles((theme) => ({
  root: {},
  NoZoomField: {
    fontSize: '16px',

  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function LoginForm({ className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('login');
  const [Loading, setLoading] = useState(false);
  const history = useHistory();
  const [IPAdres, setIPAdres] = useState('');
  const publicIp = require('public-ip');
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [DeviceId, setDeviceId] = React.useState('');


  React.useEffect(() => {
    const redirect = setUserSessionFromLocale();
    if (redirect) {
      history.push('/profile/1/timeline');
    }
    (async () => {
      setIPAdres(await publicIp.v4());
    })();
    const uuid = new DeviceUUID().get();
    setDeviceId(uuid);
    // eslint-disable-next-line
  }, [])

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  const [error, setError] = useState(null);

  const handleChange = (event) => {
    event.persist();
    setFormState((prevFormState) => ({
      ...prevFormState,
      values: {
        ...prevFormState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...prevFormState.touched,
        [event.target.name]: true
      }
    }));
  };

  const SaveMenu = async (UserId, AuthToken) => {
    const dataMenu = [{
      UserName: UserId
    }];
    const configMenu = {
      headers: {
        'Content-Type': 'application/json',
        IpAddress: IPAdres,
        'max-age': 86400,
        'X-Frame-Options': 'DENY',
        'X-XSS-Protection': '1; mode=block',
        SessionToken: AuthToken,
      }
    };
    const AddressMenu = `${process.env.REACT_APP_API_URL}/Technician/GetUserMenu`;
    axios2.post(AddressMenu, dataMenu, configMenu)
      .then((response) => {
        const MenuData = response.data.length === 0 ? [] : response.data;
        sessionStorage.setItem('MenuData', JSON.stringify(MenuData));
        localStorage.setItem('MenuData', JSON.stringify(MenuData));
        history.push('/profile/1/timeline');
      }).catch((error) => {
        setError('Yetkiniz bulunmuyor.Lütfen yetkilerinizi tanımlatınız!...');
        setLoading(false);
      });
  };

  const handleLogin = async (event) => {
    if (isMobile) {
      if (mobileModel === 'iPhone') {
        if (!window.navigator.standalone) {
          setUyari('Mobil tarayıcı üzerinden giriş yapılamamaktadır. Mobil cihazınıza uygulama olarak eklemeniz gerekiyor!..');
          setOpen(true);
          return;
        }
      } else if (!window.matchMedia('(display-mode: standalone)').matches) {
        setUyari('Mobil tarayıcı üzerinden giriş yapılamamaktadır. Mobil cihazınıza uygulama olarak eklemeniz gerekiyor!..');
        setOpen(true);
        return;
      }
    }
    setError(null);
    setLoading(true);
    const dataUser = [{
      UserName: Base64.encode(formState.values.UserName),
      TerminalId: DeviceId || '1',
      VersionNr: process.env.REACT_APP_VERSION,
      TerminalIp: IPAdres || '1',
      LanguageId: '1',
      Password: Base64.encode(formState.values.password)
    }];
    const configUser = {
      headers: {
        'Content-Type': 'application/json',
        IpAddress: IPAdres,
        'max-age': 86400,
        'X-Frame-Options': 'DENY',
        'X-XSS-Protection': '1; mode=block',
        'User-LanguageId': localStorage.getItem('i18nextLng')
      }
    };
    const Address = `${process.env.REACT_APP_API_URL}/Technician/GetUserAuthorization`;
    axios2.post(Address, dataUser, configUser)
      .then((response) => {
        if (response.data[0].SessionToken === undefined) {
          setError('Kullanıcı Adı ve Parolanızı kontrol ediniz!...');
          setLoading(false);
        } else {
          setSessionToken(response.data[0].SessionToken, response.data[0].SessionTokenWs || '');
          setIpAddress(IPAdres);
          setUserSession(response.data[0].SessionToken, response.data[0].SessionTokenWs || '', response.data[0]);
          setLoading(false);
          NavBarAdetleriAl(response.data[0].ServiceShopId, response.data[0].TechnicianId);
          SaveMenu(response.data[0].UserId, response.data[0].SessionToken);
          setLoading(false);
          localStorage.removeItem('ArtemisApp');
          sessionStorage.removeItem('ArtemisApp');
          localStorage.setItem('ArtemisApp', 1);
          sessionStorage.setItem('ArtemisApp', 1);
          history.push('/profile/1/timeline');
        }
      }).catch((error) => {
        setError('Kullanıcı Adı ve Parolanızı kontrol ediniz!...');
        setLoading(false);
      });
  };


  const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState((prevFormState) => ({
      ...prevFormState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleClose = () => {
    setOpen(false);
  };

  const meta = document.createElement('meta');
  meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  meta.setAttribute('name', 'viewport');
  document.head.appendChild(meta);
  return (
    <form
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">Bilgilendirme</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {
        Loading
          ? (
            <Backdrop className={classes.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          )
          : <div />
      }
      <div className={classes.fields}>
        <TextField
          fullWidth
          className={classes.NoZoomField}
          label={t('Kullanici_Adi')}
          name="UserName"
          onChange={handleChange}
          value={formState.values.UserName || ''}
          variant="outlined"
        />
        <TextField
          error={hasError('password')}
          fullWidth
          helperText={
            hasError('password') ? formState.errors.password[0] : null
          }
          label={t('Parola')}
          name="password"
          onChange={handleChange}
          type="password"
          value={formState.values.password || ''}
          variant="outlined"
        />
      </div>
      {error && (
      <>
        <small style={{ color: 'red' }}>{error}</small>
        <br />
      </>
      )}
      <br />
      <Button
        className={classes.submitButton}
        color="secondary"
        size="large"
        variant="contained"
        endIcon={<LockOpenIcon>Kaydet</LockOpenIcon>}
        onClick={handleLogin}
      >
        {t('Giris')}
      </Button>
    </form>
  );
}

LoginForm.propTypes = {
  className: PropTypes.string
};

export default LoginForm;
